import IGlass from 'components/interfaces/IGlass';

const getDefaultGlass = (): IGlass => ({
  width: 0,
});

export default getDefaultGlass;
